import { request } from '@max/meituan-uni-network';
const isWeb = true;
import { AntiReqTool } from '@nibfe/h5guard-request';
// const API_ROOT = isDebug() ? "http://1962-mlxyc-sl-api.train.test.sankuai.com" : "https://i.meituan.com/uts/train";
const API_ROOT = "https://i.meituan.com/uts/train";
export const AJAX_ERROR_NAME = '网络错误';
export const fetchData = (data) => {
    let finalData = data;
    if (true) {
        try {
            const antiReq = new AntiReqTool({
                autoFillParams: true
            });
            // @ts-ignore
            finalData = antiReq.addCommonParams(finalData);
        }
        catch (e) {
            console.warn('添加反爬参数失败', e);
            // reportJSInfo({ level: 'info', content: '请求加上反爬参数错误', secCategory: 'ajaxError' });
        }
    }
    return new Promise((resolve, reject) => {
        request({
            url: `${API_ROOT}/active/trip/recommend`,
            method: 'GET',
            data: Object.assign({}, finalData),
            header: {
                'Content-Type': 'application/json'
                // 'swimlane': 'xiongjunjie05-tfctv',
            },
            // _meituan: {
            //   requestType: 'MRNUtils',
            //   enableElinkLog: true
            // },
            success(res) {
                var _a, _b;
                if (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.status) === 0) {
                    const hotCitiesRes = (_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.data;
                    resolve(hotCitiesRes);
                }
                else {
                    const error = new Error(AJAX_ERROR_NAME);
                    error.name = AJAX_ERROR_NAME;
                    error.message = '请求接口异常-code非200';
                    reject(error);
                }
            },
            fail(error) {
                console.log('失败');
                error.name = AJAX_ERROR_NAME;
                error.message = '请求接口异常-网络异常';
                reject(error);
            }
        });
    });
};
